import { render, staticRenderFns } from "./Smails.vue?vue&type=template&id=3827ddb0&"
import script from "./Smails.vue?vue&type=script&lang=js&"
export * from "./Smails.vue?vue&type=script&lang=js&"
import style0 from "./Smails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports